module.exports = __webpack_public_path__ + "img/bingo_ball-54.13263175.png";